import React from 'react';
import { CreditCardIcon, DownloadIcon, MailIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
const badges = ['DOWNLOAD IMMEDIATO', 'PAGAMENTO SICURO', 'ACCESSO A VITA', 'GARANZIA 30 GIORNI'];
const steps = [{
  icon: CreditCardIcon,
  label: '1. Paghi in modo sicuro'
}, {
  icon: MailIcon,
  label: '2. Ricevi subito l’email'
}, {
  icon: DownloadIcon,
  label: '3. Scarichi tutto'
}];
export function PricingSection() {
  return <section id="offer" aria-labelledby="offer-title" className="scroll-mt-9 bg-brand-alt px-4 py-12 md:py-20" data-id="element-201" data-mp="1s9dee3qwz5tc">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-202" data-mp="1x86wk9h5bkzu">
        <p className="mb-3 text-xs font-extrabold uppercase tracking-[0.18em] text-brand-teal" data-id="element-203" data-mp="1x6nc06ogins9">OFFERTA DI LANCIO</p>
        <h2 id="offer-title" className="text-3xl font-extrabold tracking-tight text-brand-primary md:text-4xl" data-id="element-204" data-mp="2up3y81vvxxy">
          🏷 Offerta Speciale di Lancio
        </h2>
        <p className="mx-auto mb-12 mt-4 max-w-xl text-xs italic leading-relaxed text-brand-gray" data-id="element-205" data-mp="7ubpr5vs2mid">
          Prezzo di lancio riservato ai primi acquirenti. Al termine del lancio il pacchetto tornerà al prezzo pieno.
        </p>
        <div className="relative mx-auto max-w-xl rounded-[20px] border-2 border-brand-accent bg-brand-alt p-6 pt-10 shadow-lg md:p-10 md:pt-12" data-id="element-206" data-mp="1ho544mudmujr">
          <div className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-brand-accent px-5 py-2 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-207" data-mp="17stjxp078v4m">
            EDUCAZIONE FISICA PRONTA™
          </div>
          <div className="space-y-4 text-left" data-id="element-208" data-mp="1vh31geqdqwpy">
            <PriceLine label="8 Volumi Completi" price="97 €" data-id="element-209" data-mp="1vfry2g0ujqzd" />
            <PriceLine label="5 Bonus Esclusivi" price="128 €" data-id="element-210" data-mp="1rgatdot8uxv9" />
            <div className="flex items-center justify-between border-t border-brand-sand pt-5 text-sm font-bold" data-id="element-211" data-mp="1ri3zn2zy3g2q">
              <span data-id="element-212" data-mp="g0m58u497ssv">TOTALE VALORE</span>
              <span className="text-brand-gray line-through" data-id="element-213" data-mp="fzjhgv28a6h6">225 €</span>
            </div>
          </div>
          <div className="my-8 border-y border-brand-sand py-7" data-id="element-214" data-mp="hj2vuv3p41d7">
            <p className="text-xs font-extrabold uppercase tracking-[0.16em] text-brand-teal" data-id="element-215" data-mp="mhe6v95q8hx0">SOLO OGGI</p>
            <p className="mt-2 font-display text-6xl font-extrabold tracking-tight text-brand-accent md:text-7xl" data-id="element-216" data-mp="7k3pjj6ekhtd">
              19 <span className="text-2xl" data-id="element-217" data-mp="chn82va4vgr4">EUR</span>
            </p>
            <p className="mt-2 text-xs text-brand-gray" data-id="element-218" data-mp="3uwxvtvzd7e69">(pagamento unico)</p>
          </div>
          <ul className="mb-6 flex flex-wrap items-center justify-center gap-2" data-id="element-219" data-mp="3i0bcmscmz4e">
            {badges.map(badge => <li key={badge} className="rounded-full bg-brand-cream px-3 py-1.5 text-[9px] font-extrabold uppercase tracking-[0.1em] text-brand-primary" data-id="element-220" data-mp="3kz9o85gnuc6o">
                {badge}
              </li>)}
          </ul>
          <CTAButton target="checkout" className="w-full py-5 text-sm md:text-base" data-id="element-221" data-mp="3fzducz1og14u" />
          <ul className="mt-6 grid grid-cols-3 gap-2 border-t border-brand-sand pt-5" data-id="element-222" data-mp="3g1873q2somxu">
            {steps.map(({
            icon: StepIcon,
            label
          }) => <li key={label} className="flex flex-col items-center gap-1.5 text-center" data-id="element-223" data-mp="2scs0qg29nww0">
                <StepIcon className="h-5 w-5 text-brand-accent" strokeWidth={1.6} aria-hidden="true" data-id="element-224" data-mp="36c1ktqtlfb59" />
                <span className="text-[10px] font-semibold leading-tight text-brand-primary md:text-[11px]" data-id="element-225" data-mp="31cf59aqalita">
                  {label}
                </span>
              </li>)}
          </ul>
          <p className="mt-3 text-xs text-brand-gray" data-id="element-226" data-mp="3b9tb6gelap7c">Ricevi tutto entro 2 minuti.</p>
          <p className="mt-5 text-xs font-bold text-brand-gray" data-id="element-227" data-mp="3p2socbqwg7bq">
            Pagamento unico. Nessun abbonamento. Accesso immediato.
          </p>
        </div>
      </Reveal>
    </section>;
}
function PriceLine({
  label,
  price
}: {
  label: string;
  price: string;
}) {
  return <div className="flex items-center justify-between gap-4 border-b border-brand-sand pb-4 text-sm" data-id="element-228" data-mp="3u1dt8oh3jf6i">
      <span className="font-medium" data-id="element-229" data-mp="hycdqrym2i8l">{label}</span>
      <span className="whitespace-nowrap font-bold text-brand-primary" data-id="element-230" data-mp="hxktueedm8y5">{price}</span>
    </div>;
}